"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Divider_st_css_1 = require("./Divider.st.css");
/**
 * Divider
 */
exports.Divider = function (props) {
    var children = props.children, vertical = props.vertical;
    var customDivider = !!children;
    return (React.createElement("div", tslib_1.__assign({}, Divider_st_css_1.default('root', { vertical: vertical && !customDivider, customDivider: customDivider }, props)), children));
};
exports.Divider.displayName = 'Divider';
//# sourceMappingURL=Divider.js.map